export function formatIST(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '—';

  const options = {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  };

  const parts = new Intl.DateTimeFormat('en-GB', options).formatToParts(d);
  const get = (type) => parts.find(p => p.type === type)?.value;

  return `${get('day')} ${get('month')} ${get('year')} ${get('hour')}:${get('minute')}`;
}

export function formatISTDateOnly(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '—';

  const options = { timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: '2-digit' };
  const parts = new Intl.DateTimeFormat('en-GB', options).formatToParts(d);
  const get = (type) => parts.find(p => p.type === type)?.value;

  return `${get('day')} ${get('month')} ${get('year')}`;
}
